import { render, staticRenderFns } from "./purchaseOrderHistory.vue?vue&type=template&id=bfca5ce2&scoped=true"
import script from "./purchaseOrderHistory.vue?vue&type=script&lang=js"
export * from "./purchaseOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderHistory.vue?vue&type=style&index=0&id=bfca5ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfca5ce2",
  null
  
)

export default component.exports